import{Button as Nt,InlineMessage as xt,Input as yt,Row as Lt}from"@appcues/sonar";import{useForm as wt}from"react-hook-form";import{Button as ut,Form as ft,InlineMessage as vt,Input as ht}from"@appcues/sonar";import kt,{css as bt}from"styled-components";var It=bt`
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  input[type='number'] {
    -moz-appearance: textfield;
  }
`,Re=kt(ft)`
  padding: var(--spacing-regular);
  padding-bottom: 0;

  ${ut} {
    flex: 1;
  }

  ${ht} {
    flex: 2;
    ${It};
  }

  ${vt} {
    padding-top: var(--spacing-small);
  }
`;import{jsx as de,jsxs as Ee}from"react/jsx-runtime";var W=({user:e,isSpoofing:t,onSpoof:i})=>{let{register:n,handleSubmit:r,formState:{errors:s,isSubmitting:a},setError:m}=wt(),{isAdmin:l}=e!=null?e:{};return!l||t?null:Ee(Re,{onSubmit:r(async({accountId:p})=>{try{await i(p)}catch(h){m("accountId",{message:"Failed to spoof"})}}),children:[Ee(Lt,{xAlign:"center",spacing:"small",children:[de(yt,{id:"accountId",placeholder:"Account ID",type:"number",...n("accountId",{required:"Can't be empty"})}),de(Nt,{type:"submit",disabled:a,children:"Spoof"})]}),s.accountId&&de(xt,{variant:"error",children:s.accountId.message})]})};import Be from"styled-components";var Fe=Be.header`
  align-items: center;
  display: flex;
  justify-content: center;
  padding-bottom: var(
    ${({$size:e})=>e==="regular"?"--spacing-large":"--spacing-x-large"}
  );
  padding-top: var(
    ${({$size:e})=>e==="regular"?"--spacing-large":"--spacing-x-large"}
  );
`,We=Be.span`
  align-items: center;
  color: var(--color-blurple-600);
  display: flex;
  font-size: var(--icon-size-large);
  justify-content: center;

  svg {
    height: 30px;
    width: 24px;

    path {
      fill: currentColor;
    }
  }
`;import{jsx as D}from"react/jsx-runtime";var $=({size:e="regular"})=>D(Fe,{$size:e,children:D("a",{href:"/",children:D(We,{children:D("svg",{viewBox:"0 0 1600 2000",xmlns:"http://www.w3.org/2000/svg",role:"img","aria-label":"Appcues logo",children:D("path",{d:"M695.6 1083.4l555.9 870.5c14.1 21.2 35.3 31 60.7 31h206c39.5 0 70.5-31 70.5-70.5V70.4c0-66.3-83.2-95.9-127-43.7L695.6 998.8c-16.9 22.6-16.9 57.8 0 84.6zM70.6 1985h366.8c39.5 0 70.5-31 70.5-70.5V1446c0-66.3-83.2-95.9-127-43.7L14.1 1870.7c-35.2 48 0 114.3 56.5 114.3z"})})})})});import O from"styled-components";import{Stack as At}from"@appcues/sonar";var De=O(At).attrs({spacing:"none"})`
  position: fixed;
  bottom: 0;
  left: 0;
  top: 0;
  width: 240px;
  background-color: var(--color-neutral-0);
  border-right: 1px solid var(--border-default);
  display: flex;
  flex-direction: column;
  /*
  * This z-index is chosen because it is bigger than the biggest z-index currently
  * found in studio excluding Modals, which is in the studio classic TabsRoot
  * component (z-index: 3000). We will look at standardizing our use of z-index in
  * studio in the future.
  */
  z-index: 4000;
`,$e=O.div`
  overflow-y: auto;
  flex-grow: 1;
`,Oe=O.nav`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`,He=O.ul`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-x-small);
  padding-bottom: var(--spacing-small);
  padding-top: var(--spacing-small);
  list-style-type: none;
`,Y=O.div`
  width: 18px;
  height: 14px;
`;import{Icon as St,Row as Tt,Text as Pt}from"@appcues/sonar";import ze from"styled-components";import{Text as Ue}from"@appcues/sonar";var J=ze.li`
  a {
    height: 40px;
    display: flex;
    text-decoration: none;
    padding-left: var(--spacing-large);
    transition: background-color 0.3s ease;

    svg {
      display: block;
      // We use 18px because the banners icon requires a width of 18px
      width: 18px;

      path {
        transition: fill 0.3s ease;
      }
    }
    &.active {
      background-color: var(--color-neutral-50);
      border-radius: var(--border-radius-small);

      ${Ue} {
        font-weight: var(--font-weight-bold);
      }

      svg path {
        fill: var(--color-blurple-600);
      }
    }

    :hover {
      background-color: var(--color-neutral-50);
      border-radius: var(--border-radius-small);

      svg path {
        fill: var(--color-blurple-600);
      }
    }
  }
`,Ge=ze.button.attrs({type:"button"})`
  height: 40px;
  display: flex;
  align-items: center;
  padding-left: var(--spacing-large);
  padding-right: var(--spacing-regular);
  transition: background-color 0.3s ease;
  border-color: transparent;
  background-color: transparent;
  width: 100%;

  svg {
    display: block;
    // We use 18px because the banners icon requires a width of 18px
    width: 18px;

    path {
      transition: fill 0.3s ease;
    }
  }
  &.active {
    background-color: var(--color-neutral-50);
    border-radius: var(--border-radius-small);

    ${Ue} {
      font-weight: var(--font-weight-bold);
    }

    svg path {
      fill: var(--color-blurple-600);
    }
  }

  :hover {
    background-color: var(--color-neutral-50);
    border-radius: var(--border-radius-small);

    svg path {
      fill: var(--color-blurple-600);
    }
  }
`;import{jsx as Z,jsxs as Ct}from"react/jsx-runtime";var _e=({children:e,icon:t,iconElement:i,NavLink:n,to:r,end:s,isActive:a,className:m,external:l=!1,isSubItem:d=!1,...p})=>Z(J,{className:m,children:Z(l||!n?"a":n,{isSubItem:d,to:r,end:s,className:a?"active":"",...p,children:Ct(Tt,{spacing:"small",yAlign:"center",children:[i&&i,t&&Z(St,{icon:t,colorToken:"foreground-secondary",size:"small"}),Z(Pt,{colorToken:"foreground-primary",children:e})]})})});import{useState as Ft}from"react";import{Accordion as Wt,Row as Dt}from"@appcues/sonar";import{Accordion as j,Icon as Bt}from"@appcues/sonar";import H,{css as Ye}from"styled-components";import ue,{css as Mt}from"styled-components";import{Row as Rt,Text as Ve}from"@appcues/sonar";var Et=Mt`
  padding: 0 var(--spacing-regular);
`,Q=ue.div`
  a {
    height: ${({variant:e="regular"})=>e==="regular"?"40px":"64px"};
    display: flex;
    text-decoration: none;
    padding: 0 var(--spacing-large);
    ${({isSubItem:e})=>e&&Et}
    transition: background-color 0.3s ease;

    svg {
      display: block;
      // We use 18px because the banners icon requires a width of 18px
      width: 18px;

      path {
        transition: fill 0.3s ease;
      }
    }

    &.active {
      background-color: var(--color-neutral-50);
      border-radius: var(--border-radius-small);

      ${Ve} {
        font-weight: var(--font-weight-bold);
      }

      svg path {
        fill: var(--color-blurple-600);
      }
    }

    :hover {
      background-color: var(--color-neutral-50);
      border-radius: var(--border-radius-small);

      svg path {
        fill: var(--color-blurple-600);
      }
    }
  }
`,Ke=ue(Rt)`
  max-width: 100%;
`,qe=ue(Ve).attrs({forwardedAs:"span"})`
  flex: 1;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;var fe=Ye`
  fill: var(--color-blurple-600);
`,ve=H(Bt)`
  display: block;
  // 18px is used so that the accordion icon aligns with the other nav item icons
  width: 18px;

  path {
    transition: fill 0.3s ease;
    // The active state is determined programatically because when the accordion is closed the active list item is reomved from the DOM
    ${({$isActive:e})=>e&&fe}
  }
`,Xe=Ye`
  background-color: var(--color-neutral-50);
  border-radius: var(--border-radius-small);
`,Je=H(j.Header)`
  height: 40px;
  display: flex;
  // The Sonar Accordion.Header has some padding that we need to override so that the correct hover background can be applied
  padding: 0;
  font-weight: var(--font-weight-regular);
  transition: background-color 0.3s ease;

  :hover {
    ${Xe};

    ${ve} {
      path {
        ${fe};
      }
    }
  }

  /* Shows accordion header as active if collapsed */
  &[data-state='closed'] {
    ${({$isActive:e})=>e&&Xe};
  }
`,Ze=H(j.Trigger)`
  color: var(--foreground-primary);
  padding-left: var(--spacing-large);
  padding-right: var(--spacing-regular);
`,Qe=H(j.Content)`
  p {
    // Padding of 26px is required so that the accordion content aligns correctly with the other nav item text
    padding-left: 26px;
  }

  // We don't want padding on the last list item because a 4px space is already provided by the flex gap
  li {
    &:not(:last-child) {
      padding-bottom: var(--spacing-x-small);
    }
  }
`,je=H(j.Item)`
  // These styles create a gap between the trigger and the content when the accordion is expanded, but
  // the gap is removed when the accordion is collapsed
  display: flex;
  flex-direction: column;
  gap: var(--spacing-x-small);

  // This selector is used to apply the blurple fill to the accordion icon when one of it's children is hovered
  &:has(div > li > a:hover) {
    div > svg > path {
      ${fe}
    }
  }

  ${Q} {
    margin-left: var(--spacing-x-large);
    margin-right: var(--spacing-small);
    position: relative;
    &::before {
      content: '';
      display: block;
      width: 1px;
      height: 100%;
      background-color: var(--color-neutral-300);
      position: absolute;
      left: 0;
      top: 0;
    }
  }
`;import{jsx as z,jsxs as oo}from"react/jsx-runtime";var $t="@navigation/accordion_",eo={getAccordionKey(e){return`${$t}${e}`},getAccordionValue(e){let t=this.getAccordionKey(e);return localStorage.getItem(t)},setAccordionValue(e,t){let i=this.getAccordionKey(e);Boolean(t)?localStorage.setItem(i,t):localStorage.removeItem(i)}},to=({children:e,text:t,icon:i,isActive:n})=>{let r=()=>{if(n)return t;let l=eo.getAccordionValue(t);if(l)return l},[s,a]=Ft(r()),m=l=>{a(l),eo.setAccordionValue(t,l)};return z(Wt.Root,{collapsible:!0,value:s,onValueChange:m,type:"single",$unstyled:!0,children:oo(je,{value:t,children:[z(Je,{$isActive:n,children:z(Ze,{children:oo(Dt,{spacing:"small",yAlign:"center",children:[z(ve,{icon:i,colorToken:"color-neutral-700",size:"small",$isActive:n}),t]})})}),z(Qe,{children:e})]})})};import{jsx as no}from"react/jsx-runtime";var io=({children:e,isActive:t,onClick:i})=>no(J,{children:no(Ge,{onClick:i,className:t?"active":"",children:e})});import{Icon as ao,Row as ro,Text as Ot}from"@appcues/sonar";import{faChevronRight as Ht}from"@fortawesome/pro-solid-svg-icons/faChevronRight";import{jsx as ee,jsxs as so}from"react/jsx-runtime";var lo=({icon:e,label:t})=>so(ro,{xAlign:"space-between",yAlign:"center",children:[so(ro,{spacing:"small",yAlign:"center",children:[ee(Y,{children:ee(ao,{icon:e,colorToken:"foreground-secondary",size:"small"})}),ee(Ot,{colorToken:"foreground-primary",forwardedAs:"span",children:t})]}),ee(ao,{icon:Ht,colorToken:"foreground-secondary",size:"small"})]});import{forwardRef as zt}from"react";import{Icon as Ut,NavigationMenu as Gt}from"@appcues/sonar";import{jsx as M,jsxs as _t}from"react/jsx-runtime";var po=zt(({children:e,icon:t,iconElement:i,NavLink:n,to:r,end:s,isActive:a,external:m=!1,isSubItem:l,variant:d="regular",title:p,...h},v)=>{let I=m||!n?"a":n;return M(Q,{isSubItem:l,variant:d,className:"accordion-link-item",children:M(Gt.Link,{asChild:!0,children:M(I,{ref:v,to:r,end:s,className:a?"active":"",...h,children:_t(Ke,{fluid:!0,spacing:"small",yAlign:"center",children:[i&&i,t&&M(Y,{children:M(Ut,{icon:t,colorToken:"foreground-secondary",size:"small"})}),M(qe,{colorToken:"foreground-primary",title:p||"",children:e})]})})})})});import{NavigationMenu as qt}from"@appcues/sonar";import Vt from"styled-components";import{Text as Kt}from"@appcues/sonar";var co=Vt.button.attrs({type:"button"})`
  height: 40px;
  display: flex;
  align-items: center;
  padding: 0 var(--spacing-regular);
  transition: background-color 0.3s ease;
  border-color: transparent;
  background-color: transparent;
  width: 100%;
  border: 0;

  svg {
    display: block;
    // We use 18px because the banners icon requires a width of 18px
    width: 18px;

    path {
      transition: fill 0.3s ease;
    }
  }
  &.active {
    background-color: var(--color-neutral-50);
    border-radius: var(--border-radius-small);

    ${Kt} {
      font-weight: var(--font-weight-bold);
    }

    svg path {
      fill: var(--color-blurple-600);
    }
  }

  :hover {
    background-color: var(--color-neutral-50);
    border-radius: var(--border-radius-small);

    svg path {
      fill: var(--color-blurple-600);
    }
  }
`;import{jsx as mo}from"react/jsx-runtime";var go=({children:e,onClick:t,className:i})=>mo(qt.Link,{asChild:!0,children:mo(co,{onClick:t,className:i,children:e})});var o={Wrapper:De,ScrollContainer:$e,NavList:He,Nav:Oe,NavItem:_e,NavButton:io,NavAccordion:to,NavTrigger:lo,LinkItem:po,ButtonItem:go};import{useEffect as he}from"react";function uo({user:e,account:t,cannyAppId:i,isOpen:n}){he(()=>{if(window.Canny&&t&&e){let{id:r,isTrial:s,tier:a,stripePlanId:m}=t,{fullname:l,email:d,id:p,job:h,crxVersion:v}=e;window.Canny("identify",{appID:i,user:{email:d,name:l||"anonymous",id:p,customFields:{job:h,crxVersion:v},companies:[{customFields:{isTrial:s,tier:a,stripePlanId:m},id:r,name:r}]}})}},[t,i,e]),he(()=>{!n&&window.Canny&&window.Canny("closeChangelog")},[n]),he(()=>{new MutationObserver(()=>{if(document.querySelector("[data-canny-changelog]"))try{window.Canny("initChangelog",{appID:i,position:"right",align:"bottom"})}catch(a){}}).observe(document.body,{childList:!0,subtree:!0})},[i])}import{Icon as tn,Row as nn,Tooltip as an}from"@appcues/sonar";import{faScrewdriverWrench as rn}from"@fortawesome/pro-solid-svg-icons/faScrewdriverWrench";import G from"styled-components";import{Button as en,Stack as on,NavigationMenu as No}from"@appcues/sonar";import{Progress as Qt}from"@appcues/sonar";import jt from"pluralize";import{differenceInDays as Xt}from"date-fns";var ke=(e,t)=>Xt(e,t),fo=e=>new Intl.DateTimeFormat(void 0,{year:"numeric",month:"short",day:"2-digit"}).format(e);var be=(e,t)=>!((e==null?void 0:e.stripePlanId)||(t==null?void 0:t.isExpired));import U from"styled-components";import{Skeleton as Yt}from"@studio/legacy-components";import{Button as Jt,Tooltip as Zt}from"@appcues/sonar";var vo=U.div`
  text-align: center;
  gap: 8px;
  padding: 16px 24px 0 24px;
  display: flex;
  flex-direction: column;

  ${Yt} {
    width: 140px;
    height: 40px;
    margin: 0 auto;
  }

  ${Jt} {
    --link-color: #ffffff;
    --link-text-decoration: none;
    --link-visited-color: #ffffff;
  }
`,ho=U.div`
  font-weight: 700;
  color: rgb(57, 68, 85);
  font-size: 14px;
`,ko=U.div`
  display: flex;
  gap: 8px;
  flex-direction: column;
  width: 100%;
`,bo=U.div`
  width: 180px;
  white-space: pre-wrap;
  font-size: 0.75rem;
`,Io=U(Zt)`
  width: 100%;
`;import{jsx as oe,jsxs as Ie}from"react/jsx-runtime";var Ne=({account:e={},trialStatus:t={},className:i,Link:n})=>{let{createdAt:r,expirationDate:s,isWebInstalled:a,lengthDays:m}=t;if(!be(e,t)||!r||!s)return null;let d=ke(new Date(s),new Date(r))+1,p=ke(new Date(s),new Date)+1,v=(d-p)/d,I=Math.round(v*100),k=p>7?"default":(p>3,"error"),b=Ie(bo,{children:["Trial expires on ",fo(new Date(s)),"."," ",a?"":`Install the Appcues SDK to extend your trial another ${m} days.`]});return Ie(vo,{className:i,children:[oe(Io,{placement:"right",content:b,children:Ie(ko,{children:[oe(ho,{children:`${p} ${jt("day",p)} left in trial`}),oe(Qt,{value:I,max:100,variant:k})]})}),oe(n,{to:"/subscription",children:"Upgrade now"})]})};var te=G(No.Trigger)`
  height: 40px;
`,xo=G(on).attrs({spacing:"large"})`
  padding: var(--spacing-large);
`,yo=G(Ne)`
  padding: 0;
`,xe=G(en)`
  width: 100%;
  text-decoration: none;
`,R=G(No.Content)`
  position: absolute;
  transform: translateY(-40px);
  left: 100%;
  margin-left: var(--spacing-x-small);
  background-color: var(--color-neutral-0);
  border-radius: var(--border-radius-small);
  gap: var(--spacing-x-small);
  padding: var(--spacing-small) var(--spacing-x-small);
  box-shadow: var(--elevation-300);
  transform: translateY(-40px);
  width: 200px;

  ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }
`;import{jsx as _,jsxs as Lo}from"react/jsx-runtime";var wo=({NavLink:e,isInstalled:t,account:i,trialStatus:n})=>Lo(xo,{children:[t?null:_(an,{size:"regular",content:"In order to publish live experiences to your users, you'll have to install Appcues directly into your codebase. Don't worry...it's super easy. Click here to learn how!",children:_(xe,{variant:"secondary",fluid:!0,forwardedAs:e,to:"/settings/installation",children:Lo(nn,{spacing:"small",yAlign:"center",children:[_(tn,{icon:rn}),"Install"]})})}),_(yo,{account:i,trialStatus:n,Link:r=>_(xe,{variant:"tertiary",forwardedAs:e,...r})})]});import{useState as Ro}from"react";import{faGear as cn}from"@fortawesome/pro-solid-svg-icons/faGear";import{faChevronRight as mn}from"@fortawesome/pro-solid-svg-icons/faChevronRight";import{faExternalLink as gn}from"@fortawesome/pro-solid-svg-icons/faExternalLink";import{faArrowRightFromBracket as dn}from"@fortawesome/pro-solid-svg-icons/faArrowRightFromBracket";import{Icon as ie,Row as Le,Stack as un,Text as we,NavigationMenu as ae}from"@appcues/sonar";import A from"styled-components";import{Text as Ao,Stack as sn,Row as ln}from"@appcues/sonar";import{Separator as pn}from"@radix-ui/react-separator";var So=A(sn).attrs({spacing:"x-small"})`
  padding-top: var(--spacing-regular);
  padding-bottom: var(--spacing-regular);
`,To=A(R)`
  transform: translateY(-105%);
  width: 237px;
`,Po=A(ln)`
  max-width: calc(100% - var(--spacing-large));
`,ne=A(Ao).attrs({colorToken:"foreground-primary",forwardedAs:"span",weight:"bold"})`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`,Co=A.div`
  display: flex;
  padding: var(--spacing-small) var(--spacing-regular);
  cursor: pointer;
`,Mo=A(Ao)`
  padding-left: 22px;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
`,ye=A(pn)`
  height: 1px;
  background: var(--border-default);
  margin: 0px var(--spacing-regular);
`;import{jsx as f,jsxs as w}from"react/jsx-runtime";var Eo=({NavLink:e,onLogout:t,user:{email:i,fullName:n}={},companyName:r,accountsCount:s})=>{let a=r||i||"",[m,l]=Ro(),[d,p]=Ro(!1),h=v=>{m&&!d&&(v.preventDefault(),p(!0)),m&&d&&p(!1)};return f(ae.Root,{orientation:"vertical",value:m,onValueChange:v=>{l(v),v||p(!1)},children:f(ae.List,{children:w(ae.Item,{value:"account-menu",children:[f(ae.Trigger,{onClick:h,children:w(So,{children:[w(Le,{xAlign:"space-between",yAlign:"center",children:[w(Po,{spacing:"small",yAlign:"center",children:[f(ie,{icon:cn,colorToken:"foreground-secondary",size:"small"}),f(ne,{title:a,children:a})]}),f(ie,{icon:mn,colorToken:"foreground-secondary",size:"small"})]}),n&&f(Mo,{title:n,size:"small",children:n})]})}),f(To,{children:w("ul",{children:[s>1?f(o.LinkItem,{isSubItem:!0,variant:"tall",NavLink:e,to:"/accounts-v2",children:w(un,{spacing:"x-small",children:[f(ne,{title:a,children:a}),f(we,{size:"small",children:"Switch Accounts"})]})}):f(Co,{children:f(ne,{title:a,children:a})}),f(ye,{}),f(o.LinkItem,{isSubItem:!0,NavLink:e,to:"/settings/account",children:"Settings"}),f(o.LinkItem,{external:!0,isSubItem:!0,"data-canny-link":!0,href:"https://feedback.appcues.com/product-feedback?sort=top",target:"_blank",children:"Suggest a feature"}),f(o.LinkItem,{external:!0,isSubItem:!0,href:"https://status.appcues.com",target:"_blank",children:w(Le,{xAlign:"space-between",yAlign:"center",children:[f(we,{forwardedAs:"span",children:"Appcues status"}),f(ie,{icon:gn,colorToken:"foreground-link"})]})}),f(ye,{}),f("li",{children:f(o.ButtonItem,{onClick:t,children:w(Le,{fluid:!0,xAlign:"space-between",yAlign:"center",children:[f(we,{colorToken:"foreground-primary",forwardedAs:"span",children:"Sign out"}),f(ie,{colorToken:"foreground-secondary",icon:dn})]})})})]})})]})})})};import V from"styled-components";import{NavigationMenu as Bo}from"@appcues/sonar";import{Separator as fn}from"@radix-ui/react-separator";var E=V(fn)`
  height: 1px;
  background: var(--border-default);
  margin: 0px var(--spacing-regular);
  padding: 0.1px 0 0 0;
`,re=V.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-regular);
  height: 100%;
  overflow-y: auto;
`,Fo=V(Bo.Root)`
  display: flex;
  flex-direction: column;
  flex-grow: 1;

  & ul {
    list-style-type: none;
  }
`,Wo=V(Bo.Root)`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow-y: auto;

  & ul {
    list-style-type: none;
  }
`,K=V.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-x-small);
`;import{useState as Go}from"react";import{NavigationMenu as pe}from"@appcues/sonar";import{faFolderMagnifyingGlass as Pn}from"@fortawesome/pro-regular-svg-icons/faFolderMagnifyingGlass";import{faTableList as Cn}from"@fortawesome/pro-solid-svg-icons/faTableList";import{faFlag as Mn}from"@fortawesome/pro-solid-svg-icons/faFlag";import{faUsers as $o}from"@fortawesome/pro-solid-svg-icons/faUsers";import{faArrowsTurnToDots as vn}from"@fortawesome/pro-solid-svg-icons/faArrowsTurnToDots";import{faMessages as hn}from"@fortawesome/pro-solid-svg-icons/faMessages";import{faMap as Oo}from"@fortawesome/pro-solid-svg-icons/faMap";import{faThumbtack as kn}from"@fortawesome/pro-solid-svg-icons/faThumbtack";import{faCheckCircle as bn}from"@fortawesome/pro-solid-svg-icons/faCheckCircle";import{faComment as In}from"@fortawesome/pro-solid-svg-icons/faComment";import{faRocket as Nn}from"@fortawesome/pro-solid-svg-icons/faRocket";import{faChartColumn as Ho}from"@fortawesome/pro-solid-svg-icons/faChartColumn";import{faBullseye as xn}from"@fortawesome/pro-solid-svg-icons/faBullseye";import{faChartPieSimple as yn}from"@fortawesome/pro-solid-svg-icons/faChartPieSimple";import{faBuildings as Ln}from"@fortawesome/pro-solid-svg-icons/faBuildings";import{faTh as wn}from"@fortawesome/pro-solid-svg-icons/faTh";import{faRectangleCode as An}from"@fortawesome/pro-solid-svg-icons/faRectangleCode";import{NavigationMenu as se}from"@appcues/sonar";import{faEnvelopeOpen as Sn}from"@fortawesome/pro-solid-svg-icons";import{jsx as Do}from"react/jsx-runtime";var B=()=>Do("svg",{width:"18",height:"16",viewBox:"0 0 18 16",fill:"none",xmlns:"http://www.w3.org/2000/svg",children:Do("path",{fillRule:"evenodd",clipRule:"evenodd",d:"M17.1258 5L14.902 8.00085L17.1246 11H1.1258L3.34967 7.99915L1.12706 5H17.1258ZM0.874146 11H0.874181L0.874181 5H0.874146V11Z",fill:"var(--foreground-secondary)"})});import{Fragment as Tn,jsx as u,jsxs as S}from"react/jsx-runtime";var zo={MESSAGING:[/^\/banners(\/.*)?$/,/^\/pins(\/.*)?$/,/^\/checklists(\/.*)?$/,/^\/nps(\/.*)?$/,/^\/nps-v2(\/.*)?$/,/^\/launchpads(\/.*)?$/,/^\/flows-v2(\/.*)?$/,/^\/embeds(\/.*)?$/],METRICS:[/^\/goals(\/.*)?$/,/^\/insights\/explorer(\/.*)?$/,/^\/insights\/charts(\/.*)?$/,/^\/email-performance(\/.*)?$/]},le=(e,t)=>t.some(i=>e.startsWith(i)),Uo=(e,t)=>t.some(i=>i.test(e)),Ae=({NavLink:e,currentPath:t,featureFlags:i,handleClick:n})=>{let{hasLaunchpads:r,hasNps2:s,hasOpenBuilderFlows:a,hasEmbeds:m}=i,l=le(t,["/flows","/mobile","/experiments"]),d=Uo(t,[...zo.MESSAGING])||l,p=le(t,["/audience/segments","/segments"]),h=le(t,["/audience/users"]),v=le(t,["/audience"])||p||h,I=Uo(t,[...zo.METRICS]);return S(Tn,{children:[u(se.Item,{children:u(o.LinkItem,{icon:vn,NavLink:e,to:"/workflows",children:"Workflows"},"/workflows")}),S(se.Item,{value:"messaging-menu",children:[u(te,{className:d?"active":"",onClick:k=>n(k,"messaging-menu"),children:u(o.NavTrigger,{icon:hn,label:"Messaging"})}),u(R,{children:S("ul",{children:[u(o.LinkItem,{icon:Oo,NavLink:e,to:"/flows",isSubItem:!0,isActive:l,children:"Flows"},"/flows"),a&&u(o.LinkItem,{icon:Oo,NavLink:e,to:"/flows-v2",isSubItem:!0,children:"Flows 2.0"},"/flows-v2"),m&&u(o.LinkItem,{icon:An,NavLink:e,to:"/embeds",isSubItem:!0,children:"Embeds"},"/embeds"),u(o.LinkItem,{iconElement:u(B,{}),NavLink:e,to:"/banners",isSubItem:!0,children:"Banners"},"/banners"),u(o.LinkItem,{icon:kn,NavLink:e,to:"/pins",isSubItem:!0,children:"Pins"},"/pins"),u(o.LinkItem,{icon:bn,NavLink:e,to:"/checklists",isSubItem:!0,children:"Checklists"},"/checklists"),u(o.LinkItem,{icon:In,NavLink:e,to:s?"/nps-v2":"/nps",isSubItem:!0,children:"NPS"},"/nps"),r&&u(o.LinkItem,{icon:Nn,NavLink:e,to:"/launchpads",isSubItem:!0,children:"Launchpads"},"/launchpads")]})})]}),S(se.Item,{value:"audiences-menu",children:[u(te,{className:v?"active":"",onClick:k=>n(k,"audiences-menu"),children:u(o.NavTrigger,{icon:$o,label:"Audiences"})}),u(R,{children:S("ul",{children:[u(o.LinkItem,{icon:yn,NavLink:e,to:"/audience/segments-v2",isSubItem:!0,isActive:p,children:"Segments"},"/audience/segments-v2"),u(o.LinkItem,{icon:$o,NavLink:e,to:"/audience/users-v2",isSubItem:!0,isActive:h,children:"Users"},"/audience/users-v2"),u(o.LinkItem,{icon:Ln,NavLink:e,to:"/audience/accounts",isSubItem:!0,children:"Accounts"},"/audience/accounts")]})})]}),S(se.Item,{value:"metrics-menu",children:[u(te,{className:I?"active":"",onClick:k=>n(k,"metrics-menu"),children:u(o.NavTrigger,{icon:Ho,label:"Metrics"})}),u(R,{children:S("ul",{children:[u(o.LinkItem,{icon:xn,NavLink:e,to:"/goals",isSubItem:!0,children:"Goals"},"/goals"),u(o.LinkItem,{icon:Ho,NavLink:e,to:"/insights/explorer",isSubItem:!0,children:"Events Explorer"},"/insights/explorer"),u(o.LinkItem,{icon:wn,NavLink:e,to:"/insights/charts",isSubItem:!0,children:"Saved Charts"},"/insights/charts"),u(o.LinkItem,{icon:Sn,NavLink:e,to:"/email-performance",isSubItem:!0,children:"Email Performance"},"/email-performance")]})})]})]})};import{jsx as L,jsxs as Rn}from"react/jsx-runtime";function Se({hasAiAssistant:e,hasOverviewRedirect:t,isInstalled:i,NavLink:n,matchExactRoutes:r,actions:s,currentPath:a,hasLaunchpads:m,hasNps2:l,hasOpenBuilderFlows:d,hasDevTools:p}){let[h,v]=Go(),[I,k]=Go({}),b=(x,N)=>{h===N&&!I[N]&&(x.preventDefault(),k({[N]:!0})),h===N&&I[N]&&k({[N]:!1})},C=(x,N)=>{b(x,N)};return L(Fo,{orientation:"vertical",value:h,onValueChange:x=>{v(x),x||k({})},children:L(pe.List,{children:Rn(re,{children:[e&&s?s:null,t&&!i?null:L(pe.Item,{children:L(o.LinkItem,{icon:Cn,NavLink:n,to:"/",end:r,children:"Overview"})}),L(K,{children:L(Ae,{NavLink:n,currentPath:a,handleClick:(x,N)=>C(x,N),featureFlags:{hasLaunchpads:m,hasNps2:l,hasOpenBuilderFlows:d}})}),L(E,{}),L(pe.Item,{children:L(o.LinkItem,{icon:Pn,NavLink:n,to:"/folders",children:"Folders"})}),p&&L(pe.Item,{children:L(o.LinkItem,{icon:Mn,NavLink:n,to:"/dev-tools",children:"Dev Tools"})})]})})})}import{NavigationMenu as Te}from"@appcues/sonar";import{faArrowsTurnToDots as En,faMessages as Bn,faMap as _o,faThumbtack as Fn,faCheckCircle as Wn,faComment as Dn,faChartColumn as Vo,faBullseye as $n,faEnvelopeOpen as On,faTh as Hn,faUsers as Ko,faChartPieSimple as zn,faBuildings as Un,faRocket as Gn,faChartLine as _n,faFlask as Vn,faRectangleCode as Kn,faLightbulb as qn}from"@fortawesome/pro-solid-svg-icons";import{faFolderMagnifyingGlass as Xn}from"@fortawesome/pro-regular-svg-icons/faFolderMagnifyingGlass";import{faTableList as Yn}from"@fortawesome/pro-solid-svg-icons/faTableList";import{faFlag as Jn}from"@fortawesome/pro-solid-svg-icons/faFlag";import{jsx as g,jsxs as F}from"react/jsx-runtime";var Zn=["/flows","/pins","/banners","/checklists","/nps","/embeds"],Qn=["/goals","/insights/explorer","/insights/charts","/email-performance"],jn=["/audience/segments-v2","/audience/users-v2","/audience/accounts"];function Pe({hasAiAssistant:e,hasOverviewRedirect:t,isInstalled:i,NavLink:n,matchExactRoutes:r,actions:s,currentPath:a,hasNps2:m,hasOpenBuilderFlows:l,hasDevTools:d,hasEmbeds:p,hasAiInsights:h}){let v=Zn.some(b=>a.startsWith(b)),I=Qn.some(b=>a.startsWith(b)),k=jn.some(b=>a.startsWith(b));return g(Wo,{orientation:"vertical",children:g(Te.List,{children:F(re,{children:[e&&s?s:null,F(K,{children:[t&&!i?null:g(o.LinkItem,{icon:Yn,NavLink:n,to:"/",end:r,children:"Overview"}),h&&g(o.LinkItem,{NavLink:n,to:"/insights-feed",icon:qn,onClick:()=>{var b;(b=window.Appcues)==null||b.track("nav_click",{navItemID:"insights-feed",navItemName:"Insights"})},children:"Insights"})]}),F(K,{children:[F(o.NavAccordion,{isActive:v,text:"Experiences",icon:Bn,children:[g(o.LinkItem,{NavLink:n,to:"/flows",icon:_o,isSubItem:!0,children:"Flows"},"/flows"),l&&g(o.LinkItem,{icon:_o,NavLink:n,to:"/flows-v2",isSubItem:!0,title:"Flows 2.0",children:"Flows 2.0"},"/flows-v2"),p&&g(o.LinkItem,{icon:Kn,NavLink:n,to:"/embeds",isSubItem:!0,title:"Embeds",children:"Embeds"},"/embeds"),g(o.LinkItem,{NavLink:n,to:"/pins",icon:Fn,isSubItem:!0,children:"Pins"},"/pins"),g(o.LinkItem,{NavLink:n,to:"/banners",iconElement:g(B,{}),isSubItem:!0,children:"Banners"},"/banners"),g(o.LinkItem,{NavLink:n,to:"/checklists",icon:Wn,isSubItem:!0,children:"Checklists"},"/checklists"),g(o.LinkItem,{NavLink:n,to:m?"/nps-v2":"/nps",icon:Dn,isSubItem:!0,children:"NPS"},"/nps"),g(o.LinkItem,{icon:Gn,NavLink:n,to:"/launchpads",isSubItem:!0,children:"Launchpads"},"/launchpads")]}),F(o.NavAccordion,{isActive:I,text:"Metrics",icon:Vo,children:[g(o.LinkItem,{NavLink:n,to:"/goals",icon:$n,isSubItem:!0,children:"Goals"},"/goals"),g(o.LinkItem,{icon:Vo,NavLink:n,to:"/insights/explorer",isSubItem:!0,children:"Events Explorer"},"/insights/explorer"),g(o.LinkItem,{icon:Hn,NavLink:n,to:"/insights/charts",isSubItem:!0,children:"Saved Charts"},"/insights/charts"),g(o.LinkItem,{NavLink:n,to:"/experiments",icon:Vn,isSubItem:!0,children:"Experiments"},"/experiments"),g(o.LinkItem,{NavLink:n,to:"/performance",icon:_n,isSubItem:!0,children:"Flow Performance"},"/performance"),g(o.LinkItem,{title:"Email Performance",icon:On,NavLink:n,to:"/email-performance",isSubItem:!0,children:"Email Performance"},"/email-performance")]}),F(o.NavAccordion,{isActive:k,text:"Audiences",icon:Ko,children:[g(o.LinkItem,{icon:zn,NavLink:n,to:"/audience/segments-v2",isSubItem:!0,children:"Segments"},"/audience/segments-v2"),g(o.LinkItem,{icon:Ko,NavLink:n,to:"/audience/users-v2",isSubItem:!0,children:"Users"},"/audience/users-v2"),g(o.LinkItem,{icon:Un,NavLink:n,to:"/audience/accounts",isSubItem:!0,children:"Accounts"},"/audience/accounts")]}),g(o.LinkItem,{NavLink:n,to:"/workflows",icon:En,children:"Workflows"},"/workflows")]}),g(E,{}),g(Te.Item,{children:g(o.LinkItem,{icon:Xn,NavLink:n,to:"/folders",children:"Folders"})}),d&&g(Te.Item,{children:g(o.LinkItem,{icon:Jn,NavLink:n,to:"/dev-tools",children:"Dev Tools"})})]})})})}import{jsx as T,jsxs as ei}from"react/jsx-runtime";var qo=({user:e,account:t,accountsCount:i,onSpoof:n,onLogout:r,isSpoofing:s,NavLink:a,featureFlags:m,matchExactRoutes:l,isInstalled:d,trialStatus:p,cannyAppId:h,currentPath:v,actions:I})=>{let{hasDevTools:k,hasLaunchpads:b,hasOverviewRedirect:C,hasAiAssistant:x,hasNps2:N,hasOpenBuilderFlows:X,hasNav2025:ge,hasEmbeds:y,hasAiInsights:dt}=m;return uo({user:e,account:t,cannyAppId:h,isOpen:!1}),ei(o.Wrapper,{children:[T(W,{user:e,onSpoof:n,isSpoofing:s}),T($,{size:"large"}),ge?T(Pe,{hasDevTools:k,hasOverviewRedirect:C,isInstalled:d,NavLink:a,matchExactRoutes:l,actions:I,currentPath:v,hasNps2:N,hasOpenBuilderFlows:X,hasAiAssistant:x,hasEmbeds:y,hasAiInsights:dt}):T(Se,{hasDevTools:k,hasLaunchpads:b,hasOverviewRedirect:C,isInstalled:d,NavLink:a,matchExactRoutes:l,actions:I,currentPath:v,hasNps2:N,hasOpenBuilderFlows:X,hasAiAssistant:x}),T(wo,{NavLink:a,isInstalled:d,account:t,trialStatus:p}),T(E,{}),T(Eo,{user:e,companyName:t==null?void 0:t.name,NavLink:a,accountsCount:i,onLogout:r})]})};import{faCircleUser as pi}from"@fortawesome/pro-solid-svg-icons/faCircleUser";import{faPeopleGroup as ci}from"@fortawesome/pro-solid-svg-icons/faPeopleGroup";import{faCreditCard as mi}from"@fortawesome/pro-regular-svg-icons/faCreditCard";import{faLaptopMobile as gi}from"@fortawesome/pro-solid-svg-icons/faLaptopMobile";import{faPaperPlane as di}from"@fortawesome/pro-solid-svg-icons/faPaperPlane";import{faPlug as ui}from"@fortawesome/pro-solid-svg-icons/faPlug";import{faDatabase as fi}from"@fortawesome/pro-solid-svg-icons/faDatabase";import{faGlobe as vi}from"@fortawesome/pro-solid-svg-icons/faGlobe";import{faSparkles as hi}from"@fortawesome/pro-solid-svg-icons/faSparkles";import{faArrowRightFromBracket as ki}from"@fortawesome/pro-solid-svg-icons/faArrowRightFromBracket";import{faPalette as bi}from"@fortawesome/pro-solid-svg-icons/faPalette";import{Icon as Ii,NavigationMenu as Qo,Row as Ni,Text as xi}from"@appcues/sonar";import oi from"styled-components";import{Button as ti,Icon as ni,Text as ii,Tooltip as ai}from"@appcues/sonar";import{faChevronLeft as ri}from"@fortawesome/pro-solid-svg-icons/faChevronLeft";import{jsx as q}from"react/jsx-runtime";var si=oi.div`
  justify-self: end;
`,Xo=({onClick:e})=>q(si,{children:q(ai,{content:q(ii,{size:"small",lineHeight:"large",colorToken:"foreground-tooltip",children:"Exit settings"}),placement:"bottom",children:q(ti,{title:"back link",variant:"tertiary",iconOnly:!0,onClick:e,children:q(ni,{icon:ri})})})});import{Text as li}from"@appcues/sonar";import Ce from"styled-components";var Yo=Ce(li)`
  padding-left: var(--spacing-large);
  padding-top: var(--spacing-regular);
  padding-bottom: var(--spacing-regular);
`,Jo=Ce.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  align-items: center;
`,Zo=Ce.div`
  padding-bottom: var(--spacing-small);
`;import{jsx as c,jsxs as P}from"react/jsx-runtime";var yi=new Set(["/settings/integrations","/webhooks","/settings/keys","/integrations/webhooks","/integrations/connections"]),Li=new Set(["/settings/events","/settings/properties","/settings/properties/users","/settings/properties/groups"]),wi=["/settings/themes",/^\/themes(\/.*)?$/],Ai=["/settings/installation",/apps\/[^/]+$/],Si=["/settings/emails/senders",/\/settings\/emails\/suppression-lists\/[^/]+$/],jo=({NavLink:e,featureFlags:t,currentPath:i,user:n,onSpoof:r,isSpoofing:s,onClickBackArrow:a,onClickLogout:m,hasLocalizationAccess:l,actions:d})=>{let{hasIntegrationPageRedesign:p,hasMobileFlows:h,hasAIAssistant:v,hasSubscription:I}=t,k=yi.has(i),b=wi.some(y=>typeof y=="string"?y===i:y.test(i)),C=Li.has(i),x=Ai.some(y=>typeof y=="string"?y===i:y.test(i)),N=Si.some(y=>typeof y=="string"?y===i:y.test(i)),X=i.includes("/settings/emails/suppression-lists/"),ge=i.startsWith("/settings/properties");return P(o.Wrapper,{children:[c(W,{user:n,onSpoof:r,isSpoofing:s}),P(Jo,{children:[c(Xo,{onClick:a}),c($,{})]}),c(Qo.Root,{orientation:"vertical",children:c(Qo.List,{children:v&&d?d:null})}),c(Yo,{size:"medium",weight:"semibold",children:"Settings"}),c(o.ScrollContainer,{children:c(o.Nav,{children:P(o.NavList,{children:[c(o.NavItem,{icon:pi,NavLink:e,to:"/settings/account",children:"Profile"}),c(o.NavItem,{icon:ci,NavLink:e,to:"/settings/team",children:"Team"}),I&&c(o.NavItem,{icon:mi,NavLink:e,to:"/settings/subscription",children:"Subscription"}),c(o.NavItem,{icon:gi,NavLink:e,to:"/settings/installation",isActive:x,children:h?"Apps & Installation":"Installation"}),c(o.NavItem,{icon:bi,NavLink:e,to:"/settings/themes",isActive:b,children:"Themes"}),v&&c(o.NavItem,{icon:hi,NavLink:e,to:"/settings/ai-assistant",children:"Appcues AI"}),P(o.NavAccordion,{text:"Emails",icon:di,isActive:N,children:[c(o.NavItem,{NavLink:e,to:"/settings/emails/senders",children:"Senders"}),c(o.NavItem,{NavLink:e,to:"/settings/emails/suppression-lists/unsubscribes",isActive:X,children:"Suppression Lists"}),c(o.NavItem,{NavLink:e,to:"/settings/emails/sending-behavior",children:"Sending Behavior"})]}),P(o.NavAccordion,{text:"Integrations",icon:ui,isActive:k,children:[c(o.NavItem,{NavLink:e,to:p?"/integrations/connections":"/settings/integrations",children:"Connections"}),c(o.NavItem,{NavLink:e,to:"/integrations/webhooks",children:"Webhooks"}),c(o.NavItem,{NavLink:e,to:"/settings/keys",children:"API Keys"})]}),P(o.NavAccordion,{text:"Data",icon:fi,isActive:C,children:[c(o.NavItem,{NavLink:e,to:"/settings/identifier",children:"Accounts & Users"}),c(o.NavItem,{NavLink:e,to:"/settings/events",children:"Events"}),c(o.NavItem,{NavLink:e,to:"/settings/properties/user",isActive:ge,children:"Properties"})]}),l&&c(o.NavItem,{icon:vi,NavLink:e,to:"/settings/localization",children:"Localization"})]})})}),c(o.NavList,{children:c(Zo,{children:c(o.NavButton,{onClick:m,children:P(Ni,{fluid:!0,xAlign:"space-between",yAlign:"center",children:[c(xi,{colorToken:"foreground-primary",children:"Sign out "}),c(Ii,{colorToken:"foreground-secondary",size:"small",icon:ki})]})})})})]})};import Ti from"styled-components";var et=Ti.div`
  flex: 0 0 220px;
  width: 220px;
  position: fixed;
  height: 100vh;
  background-color: var(--color-neutral-100);
  border-right: 1px solid var(--border-default);
  bottom: 0;
  left: 0;
  top: 0;
  z-index: 100;
`;import{jsx as Pi}from"react/jsx-runtime";var ot=()=>Pi(et,{});import{useCallback as Ci,useEffect as Mi,useRef as Ri}from"react";import{createPopup as Ei}from"@typeform/embed";var Bi={unmount:()=>{},open:()=>{}},Fi="QD5X3rU2";function tt({size:e=60,formValues:t={}}){let i=Ri(Bi);return Mi(()=>{let r={size:e,hidden:t};i.current=Ei(Fi,r)},[i,e,t]),{handleClick:Ci(()=>i.current.open(),[i])}}import nt from"styled-components";import{Link as Wi}from"@appcues/sonar";var it=nt.span`
  --font-size-regular: var(--font-size-small);
  --foreground-link: var(--color-blurple-400);
  --link-text-decoration: none;
`,at=nt(Wi)``;import{jsx as rt}from"react/jsx-runtime";var st=({children:e,message:t,subject:i,user:n,mailto:r="support@appcues.com",...s})=>{let a=(n==null?void 0:n.fullName)||(n==null?void 0:n.fullname),{email:m}=n!=null?n:{},l=["Hi,",t,"Thanks!"].join(`

`),d={message:t,subject:i,text:l,mailto:r,...a&&{name:a},...m&&{email:m}},{handleClick:p}=tt({formValues:d});return rt(it,{onClick:p,children:rt(at,{"data-testid":"typeform-beacon",icon:!1,...s,children:e})})};import{Text as zi}from"@appcues/sonar";import Di from"styled-components";import{Link as lt}from"@appcues/sonar";import{Link as $i}from"react-router-dom";import{jsx as pt}from"react/jsx-runtime";var Oi=({children:e,href:t,...i})=>t?pt(lt,{href:t,...i,children:e}):pt(lt,{forwardedAs:$i,...i,children:e}),ce=Di(Oi)``;import me from"styled-components";var Hi=me.div`
  align-items: center;
  background: white;
  box-shadow: var(--elevation-200);
  display: flex;
  height: 48px;
  justify-content: center;
`,Jl=me.div`
  position: sticky;
  width: 100%;
  top: 0;
  z-index: 9000;
  min-width: 870px;
`,ct=me(Hi)`
  background: var(--color-pink-600);
  color: white;
  gap: var(--spacing-small);
`,mt=me.div``;import{jsx as Me,jsxs as gt}from"react/jsx-runtime";var Ui=()=>Me(ce,{colorToken:"white",href:"#",onClick:e=>{e.preventDefault()},children:"Stop spoofing"});function Gi({accountId:e,spoofing:t,onDespoof:i}){return t?gt(ct,{"aria-live":"polite",role:"alert",children:[gt(zi,{weight:"bold",colorToken:"white",children:["Spoofing Account ",e]}),Me(mt,{onClick:i,children:Me(Ui,{})})]}):null}export{B as BannerIcon,st as BeaconLink,ot as BlankNavigation,ce as Link,qo as MainNavigation,o as Navigation,jo as SettingsNavigation,Gi as SpoofBanner,be as isTrialAccount};
//# sourceMappingURL=index.mjs.map